import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=3cfd2462&scoped=true&"
import script from "./ClientInfo.vue?vue&type=script&lang=ts&"
export * from "./ClientInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfd2462",
  null
  
)

export default component.exports